import React from "react";
import Img from "gatsby-image";
import { Box } from "@src/components/Boxes";
import styled from "@emotion/styled";
import Translate from "@src/components/translation/Translate";
import { mediaQueries } from "@src/styles/theme";
import { theme } from "@src/components/nessie-web";

const NewsBoxWrapper = styled("a")`
  padding: 0 15px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  min-height: 1px;
  position: relative;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
  }

  ${mediaQueries[0]} {
    width: 33%;
  }
`;

const NewsBoxStyle = styled("div")`
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #000;
  display: block;
  font-weight: 600;
  line-height: 1.42857;
  margin-bottom: 22px;
  margin-left: auto;
  margin-right: auto;
  max-width: 295px;
  padding: 0;
  position: relative;
  text-decoration: none;
  transition: border 0.2s ease-in-out;
  cursor: pointer;
  width: 100%;

  &:hover {
    text-decoration: none;
    border-color: #cdcdcd;
    box-shadow: #cdcdcd 1px 0 3px;
    outline: 0;
  }

  &:focus {
    text-decoration: none;
  }
`;

const NewsImg = styled(Img)`
  border-width: 0;
  display: block;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
`;

const LeadText = styled("p")`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0 0 15px;
  text-align: center;
`;

const SubText = styled("p")`
  bottom: 15px;
  color: ${theme.colors.dt_taro60};
  font-size: 14px;
  left: 15px;
  margin: 10px 0 0;
  position: absolute;
  right: 15px;
  text-align: center;
`;

function NewsBox({ img, url, text, source, date }) {
  return (
    <NewsBoxWrapper href={url} target="_blank">
      <NewsBoxStyle>
        <NewsImg fluid={img.childImageSharp.fluid} alt="Headline picture" />
        <Box padding="30px">
          <LeadText>
            <Translate path={text} />
          </LeadText>
          <SubText>
            <Translate path={source} />
            {", "}
            <Translate path={date} />
          </SubText>
        </Box>
      </NewsBoxStyle>
    </NewsBoxWrapper>
  );
}

export default NewsBox;
